var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between"},[_c('side-block',{attrs:{"label":"A","caption":_vm.$t('side'),"invisible":_vm.invisible.includes('A')}}),_c('side-block',{attrs:{"label":"B","caption":_vm.$t('side'),"invisible":_vm.invisible.includes('B')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }